export default __webpack_public_path__ + "static/media/enhancedSeoHero.4c4d16ea.jpg";